module.exports = __webpack_public_path__ + "static/media/Body Diagram Front.cad1ec8a.png";